import { BulkSpreadsheet, parseBool, parseNum, type BulkColumn } from '../shared/BulkSpreadsheet';
import { payrollService } from '@kss/api';
import type { PayrollCreate } from '@kss/api';
import { loadEmployeeOptions } from '../shared/formLoaders';

const columns: BulkColumn<PayrollCreate>[] = [
  { key: 'employeeId', header: 'Employee', required: true, dataType: 'lookup', loadOptions: loadEmployeeOptions },
  { key: 'period', header: 'Period (YYYY-MM)', required: true, sample: new Date().toISOString().slice(0, 7) },
  { key: 'basicSalary', header: 'Basic', dataType: 'number', parse: parseNum as never, sample: '40000' },
  { key: 'allowances', header: 'Allowances', dataType: 'number', parse: parseNum as never },
  { key: 'deductions', header: 'Deductions', dataType: 'number', parse: parseNum as never },
  { key: 'netSalary', header: 'Net', dataType: 'number', parse: parseNum as never },
  { key: 'status', header: 'Status', sample: 'Draft' },
  { key: 'isActive', header: 'Active', dataType: 'boolean', parse: parseBool as never, sample: 'true' },
];

export default function BulkPayroll() {
  return (
    <BulkSpreadsheet<PayrollCreate> title="Bulk import payrolls" entityLabel="payroll" backPath="/panel/payrolls" columns={columns} module="Payroll"
      onImport={async (rows) => {
        const payload = rows.map((r) => ({ ...r, isActive: r.isActive ?? true }));
        const created = await payrollService.create(payload);
        return { created: Array.isArray(created) ? created.length : payload.length };
      }}
    />
  );
}
